module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/ltv_strengths_img-0da1e8b2c44b72a663f1f34dd3bf7cbc.jpg";